const filtersPageTypes = {
  desks: 'Desk',
  meetings: 'Meet',
  breakout: 'Breakout',
  combinedOccupancy: 'Combined',
};

export default filtersPageTypes;
